import gql from "graphql-tag";

export const WAREHOUSE_IDS = gql`
  query warehouseIds {
    warehouses {
      id
      info {
        system
      }
    }
  }
`

export const LIST_SELLABLE_PRODUCTS = gql`
  query sellableProducts {
    sellableProducts {
      sku
      title
      type
    }
  }
`

export const GET_WAREHOUSE = gql`
  query warehouse($warehouseId:ID!) {
    warehouse(warehouseId:$warehouseId) {
      id
      location
      companyName
      contactName
      contactPhone
      contactEmail
      address {
        addressAddressLine1
        addressAddressLine2
        addressCity
        addressPostcode
        addressStateProvince
        addressCountryCode
      }
      courierId
      courierAccountNr
      hasOperationHours
      openingTime
      closingTime
      timezone
      backupWarehouseId
      reservationStatus
      info {
        system
      }
    }
  }
`;

export const LIST_PALLETS = gql`
  query pallets {
    pallets {
      createdAt
      quantity
      palletId
      sku
      state
    }
  }
`;

export const LIST_WATER_PALLETS = gql`
  query waterPallets {
    waterPallets {
      createdAt
      items
      palletId
      skus
      state
    }
  }
`;

export const LIST_WATER_PALLETS_WITH_FILTER = gql`
  query waterPallets($filter: WaterPalletsFilter) {
    waterPallets(filter: $filter) {
      createdAt
      items
      palletId
      skus
      state
    }
  }
`;

export const LIST_WATER_CONTAINERS = gql`
  query palletWaterContainers($palletId: ID!) {
    palletWaterContainers(palletId: $palletId) {
      serial
      createdAt
      palletId
      sku
      state
    }
  }
`;

export const ON_UPDATED_WATER_PALLET = gql`
  subscription onUpdatedWaterPallet {
    updatedWaterPallet {
      createdAt
      items
      palletId
      skus
      state
      testLabName
      testNr
      testRecordedAt
      testResult      
    }
  }
`;

export const ON_UPDATED_PALLET = gql`
  subscription onUpdatedPallet {
    updatedPallet {
      createdAt
      quantity
      palletId
      sku
      state
    }
  }
`;

export const ON_NEW_WATER_PALLET = gql`
  subscription onNewWaterPallet {
    newWaterPallet {
      createdAt
      items
      palletId
      skus
      state
      testLabName
      testNr
      testRecordedAt
      testResult      
    }
  }
`;

export const ON_NEW_PALLET = gql`
  subscription onNewPallet {
    newPallet {
      createdAt
      quantity
      palletId
      sku
      state
    }
  }
`;

export const WATER_PALLET = gql`
  query waterPallet($palletId: ID!) {
    waterPallet(palletId: $palletId) {
      createdAt
      items
      palletId
      skus
      state
      testLabName
      testNr
      testRecordedAt
      testResult
    }
  }
`;

export const PALLET = gql`
  query pallet($palletId: ID!) {
    pallet(palletId: $palletId) {
      createdAt
      quantity
      palletId
      sku
      state
    }
  }
`;

export const WATER_CONTAINER = gql`
  query waterContainer($serial: ID!) {
    waterContainer(serial: $serial) {
      createdAt
      serial
      palletId
      sku
      state
      testLabName
      testNr
      testRecordedAt
      testResult
    }
  }
`;

export const LIST_SHOP_PRODUCTS = gql`
  query shopProducts($shopId: ID!) {
    shopProducts(shopId: $shopId) {
      shopId
      productSku
      productTitle
      pricing {
        currency
        value
      }
      pendingPricing {
        currency
        value
      }
    }
  }
`;

export const LIST_SHOP_SUBSCRIPTION_PRODUCTS = gql`
  query shopSubscriptionProducts($shopId: ID!, $version: String) {
    shop(shopId: $shopId) {
      shopId
      subscriptionPricelistVersion
    }
    shopSubscriptionProducts(shopId: $shopId, version: $version) {
      shopId
      productSku
      productTitle
      version
      pricing {
        currency
        value
      }      
      pendingPricing {
        currency
        value        
      }  
    }
  }
`

export const ON_NEW_SHOP_PRODUCT = gql`
  subscription onNewShopProductSubscription {
    newShopProduct { 
      shopId
      productSku
      productTitle
      pricing {
        currency
        value
      }
      pendingPricing {
        currency
        value
      }
    }
  }
`;

export const ON_UPDATED_SHOP_PRODUCT = gql`
  subscription onUpdatedShopProduct {
    updatedShopProduct { 
      shopId
      productSku
      productTitle
      pricing {
        currency
        value
      }
      pendingPricing {
        currency
        value        
      }
    }
  }
`;

export const ON_UPDATED_SHOP_PRODUCTS = gql`
  subscription onUpdatedShopProducts($shopId:ID!) {
    updatedShopProducts(shopId: $shopId) { 
      shopId
    }
  }
`;

export const ON_UPDATED_SHOP_SUBSCRIPTION_PRODUCT = gql`
  subscription onUpdatedShopSubscriptionProduct {
    updatedShopSubscriptionProduct { 
      shopId
      productSku
      productTitle
      version
      pricing {
        currency
        value
      }
      pendingPricing {
        currency
        value        
      }
    }
  }
`;

export const ON_UPDATED_SHOP_SUBSCRIPTION_PRODUCTS = gql`
  subscription onUpdatedShopSubscriptionProducts($shopId:ID!) {
    updatedShopSubscriptionProducts(shopId: $shopId) { 
      shopId
    }
  }
`;



export const GET_SHOP_PRODUCT_PRICING = gql`
  query shopProductPricing($shopId: ID!, $productSku: ID!) {
    shopProduct(shopId: $shopId, productSku: $productSku) {
      shopId
      productSku      
      pricing {
        currency
        value
      }
    }
  }
`;

export const GET_CURRENT_SHOP_SUBSCRIPTION_PRODUCT_PRICING = gql`
  query getCurrentShopSubscriptionProductPricing($shopId: ID!, $productSku: ID!) {
    shopSubscriptionProductCurrentPricelist(shopId: $shopId, productSku: $productSku) {
      shopId
      productSku
      productTitle
      version
      pricing {
        currency
        value
      }      
      pendingPricing {
        currency
        value        
      }  
    }
  }
`;


export const GET_SHOP = gql`
  query shop($shopId: ID!) {
    shop(shopId: $shopId) {
      shopId
      title
      currencies
      defaultCurrency
    }
  }
`;

export const LIST_PRODUCTS = gql`
  query products($type: String) {
    products(type: $type) {
      sku
      title
      type
      nrBundled
    }
  }
`;

export const GET_PRODUCT = gql`
query product($sku: String!) {
  product(sku: $sku) {
    description
    sku
    title
    type
    weight
    width
    height
    depth
    nrBundled
  }
}
`;

export const GET_BUNDLED_PRODUCTS = gql`
  query getBundledProducts($bundle_sku:String!) {
    bundledProduct(bundleSku:$bundle_sku) {
      bundleSku
      productTitle
      productSku
      quantity
    }
  }
`;

export const GET_PRODUCT_DESCRIPTIONS = gql`
query productDescriptions($sku: String!) {
  product(sku: $sku) {
    description
    sku
    title
  }
}
`;

export const GET_PRODUCT_MEASUREMENTS = gql`
query productMeasurements($sku: String!) {
  product(sku: $sku) {
    sku
    weight
    width
    height
    depth
  }
}
`;


export const LIST_PRODUCT_TYPES = gql`
query productTypes {
  productTypes {
    type
    title
  }
}
`;

export const ON_NEW_PRODUCT = gql`
  subscription onNewProductSubscription {
    newProduct { 
      sku
      title
      type
      nrBundled
    }
  }
`;

export const ON_UPDATED_PRODUCT = gql`
  subscription onUpdatedProductSubscription {
    updatedProduct { 
      sku
      title
      description
      type
      weight
      width
      height
      depth      
      nrBundled
    }
  }
`;
